import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Token solo in memoria (mai in localStorage): fallback per contesti cross-site/iframe
// dove il cookie httpOnly SameSite=None puo' essere bloccato dal browser
let authToken = null;
export function setAuthToken(token) { authToken = token; }

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  if (authToken) config.headers.Authorization = `Bearer ${authToken}`;
  return config;
});

export async function downloadFile(path, filename) {
  const res = await api.get(path, { responseType: "blob" });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

export function wsUrl() {
  const base = BACKEND_URL.replace(/^http/, "ws");
  const q = authToken ? `?token=${encodeURIComponent(authToken)}` : "";
  return `${base}/api/ws/presence${q}`;
}
